import React, { useRef, useState, useEffect, useContext } from 'react';
import classnames from 'classnames';
import './index.less';
import getSiteConfig from '../../../siteConfig';
import { isOnIPhone } from '@/lib/utils';
import { RootContext } from '@/container';
var siteConfig = getSiteConfig(process.env.SITE_ID);
var Home = function (props) {
    var _a = useState(), profileUrl = _a[0], setProfileUrl = _a[1];
    var _b = useState(false), dowloading = _b[0], setDownloading = _b[1];
    var _c = useState(false), dowloadActive = _c[0], setDownloadingActive = _c[1];
    var theRef = useRef(null);
    var _d = useState(process.env.SITE_ID), sitid = _d[0], setSitid = _d[1];
    var _e = useContext(RootContext), state = _e.state, baseInfos = _e.baseInfos, dispatch = _e.dispatch;
    var _f = useState(0), viewHeight = _f[0], setViewHeight = _f[1];
    var _g = useState(0), viewWidth = _g[0], setViewWidth = _g[1];
    var handleDownload = function () {
        var TySCM_o = window.TySCM_o;
        if (!TySCM_o) {
            setTimeout(function () {
                handleDownload();
                setDownloading(false);
            }, 500);
            return;
        }
        // 唤起app端下载功能 （h5不一定适用）
        TySCM_o.wakeupOrInstall(function (url) {
            console.log('url: ', url);
            setProfileUrl(url);
            setTimeout(function () {
                setDownloading(false);
            }, 5000);
        });
    };
    var downloadApkH5 = function () {
        //下载地址分为 k站 s站 fat环境和生产环境
        var src = 'https://download.loqrw3.com/files/package/1022185123_app-productHttp-release.apk';
        var form = document.createElement('form');
        form.action = src;
        document.getElementsByTagName('body')[0].appendChild(form);
        form.submit();
    };
    var lookMore = function () {
        if (!theRef.current) {
            return;
        }
        var h = theRef.current.offsetHeight;
        if (!h) {
            return;
        }
        window.scrollTo({
            top: h,
            left: 0,
            behavior: 'smooth'
        });
    };
    useEffect(function () {
        setViewHeight(window.innerHeight);
        setViewWidth(window.innerWidth);
        var resizeView = function () {
            setViewHeight(window.innerHeight);
            setViewWidth(window.innerWidth);
        };
        window.addEventListener('resize', resizeView);
        console.log('viewHeight: ', viewHeight);
        return function () {
            window.removeEventListener('resize', resizeView);
        };
    }, []);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: 'mod-home', style: {
                height: viewHeight,
                width: viewWidth
            }, ref: theRef },
            React.createElement("div", { className: "btnBox" },
                React.createElement("div", { className: "downloadBtn", style: {
                        marginTop: 1038 / 1280 * viewHeight
                    }, onClick: handleDownload }, "\u7ACB\u5373\u4E0B\u8F7D")),
            React.createElement("div", { onClick: lookMore, onTouchStart: lookMore },
                React.createElement("div", { className: "moreText" }, "\u4E0B\u6ED1\u67E5\u770B\u5B89\u88C5\u6559\u7A0B"),
                React.createElement("div", { className: "center" },
                    React.createElement("img", { className: 'arrow', src: require('../../assets/img/new/home/icon-jiantou@3x.png'), alt: "" })))),
        React.createElement("div", { className: classnames("installContainer", isOnIPhone ? "iosBackImg" : "andriodBackImg"), style: {
                height: viewHeight,
                width: viewWidth,
            } })));
};
export default Home;
